module.exports = __webpack_public_path__ + "img/tg(white)-hover.43f2e932.svg";